import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 960,
      md: 1280,
      lg: 1600,
      xl: 1920,
    },
  },
});

export const COLORS = {
  BlackBackground: "#1C1C1C",
  WhiteBackground: "#EDEDED",
  White: "#fff",
  textPrimary: "#FFFFFF",
  activeBackground: "#D9D9D914",
  GOLD: "#A39455",
  iconColor: "#FFFFFF",
  dividerColor: "#E0E0E0",
  placeHolderColor: "#868585",
  typographyColor: "#1C1C1C",
  SearchFColor: "#7676801F",
  RED: "#ff4d4f",
  WarningOrange: "#FFA500",
  // Rate change colors
  rateLossBackground: "#FF8A80",
  rateChangeBackground: "#FFEEAA",
  shadeBlack: "#000000",
  // Status colors
  successGreen: "#4CAF50",
  errorRed: "#F44336",
  infoBlue: "#2196F3",
  neutralGray: "#9E9E9E",
  defaultGray: "#757575",
  lightGrayBackground: "#f9f9f9",
  // Gold multi-select / chip variants
  goldChipBackground: "#A3945522",
  goldChipBorder: "#A3945555",
  goldChipDeleteIcon: "#A3945599",
  goldButtonHoverBackground: "#A3945511",
  // Muted secondary surfaces
  mutedSurfaceBackground: "#1C1C1C18",
  mutedSurfaceBorder: "#1C1C1C30",
  // Input borders
  inputBorderDefault: "rgba(0, 0, 0, 0.23)",
  inputBorderHover: "rgba(0, 0, 0, 0.4)",
  inputHoverBackground: "rgba(0, 0, 0, 0.04)",
};
